import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';
import { NotificationSettingsModel } from '../../models/notification_settings_model';
import {
  ICategoryData,
  INotificationSettingsCategory,
  IPreference,
  IPreferenceType,
  IUpdatedPreference
} from '../../notification_settings_interfacaes';
import { EditPhoneNumberService } from '../../services/edit_phone_number_service';
import { NotifyUserService } from '../../services/notify_user_service';

type HIPCustomEvent = CustomEvent & { originalEvent: { target: { on: boolean } } };
export class NotificationSettingsCkecklistController {
  category: INotificationSettingsCategory;
  isDesktop: boolean;
  hasVerifiedPhoneNumber: boolean = true;
  submitCallback: () => void;
  showDisabledMsg: string[] = [];

  constructor(
    private notificationSettingEnum: any,
    private notificationSettingsModel: NotificationSettingsModel,
    private ngEditPhoneNumberService: EditPhoneNumberService,
    private ngNotifyUserService: NotifyUserService
  ) {}
  $onInit() {
    this.isDesktop = PlatformUtility.isDesktop();
  }

  showPreference(preference: IPreference): boolean {
    if (this.isPushNotification(preference)) {
      return !_4.isUndefined(preference.status) && !this.isDesktop;
    }
    return !_4.isUndefined(preference.status);
  }

  isPushNotification(preference: IPreference): boolean {
    return _4.isEqual(_4.toLower(preference.preferenceType.key), 'push');
  }

  isTextMessage(preference: IPreference): boolean {
    return _4.isEqual(_4.toLower(preference.preferenceType.key), 'text');
  }

  initializeToggle(preferenceObj: IPreference) {
    preferenceObj.status = preferenceObj.option === 'FORCE' || preferenceObj.status;
  }

  isPreferencePrevented(preferenceObj: IPreference) {
    return preferenceObj.option === 'PREVENT';
  }

  isValidEmail(preferenceObj: IPreference) {
    return (
      this.notificationSettingEnum.isEmail(preferenceObj.preferenceType) &&
      !preferenceObj.preferenceType.hasContactInformation()
    );
  }
  isToggleDisabled(preferenceObj: IPreference) {
    return preferenceObj.option === 'FORCE';
  }

  openEditPhoneDialog() {
    this.ngEditPhoneNumberService.contactConfig = {};
    this.ngEditPhoneNumberService.toggleOpen(true);
  }

  showDisabledErrorMsg(preferenceObj: IPreference) {
    return _4.includes(this.showDisabledMsg, _4.toLower(preferenceObj.preferenceType.key));
  }

  togglePreference(evt: HIPCustomEvent, categoryNk: ICategoryData['nk'], preferenceObj: IPreference) {
    if (this.isToggleDisabled(preferenceObj)) {
      const preferenceKey = _4.toLower(preferenceObj.preferenceType.key);
      if (!_4.includes(this.showDisabledMsg, preferenceKey)) {
        this.showDisabledMsg.push(preferenceKey);
      }
      return;
    }
    this.showDisabledMsg = [];
    if (preferenceObj.preferenceType.hasContactInformation() && preferenceObj.preferenceType.isVerified()) {
      preferenceObj.status = !preferenceObj.status;
      preferenceObj.category_nk = categoryNk;
      this.notificationSettingsModel.addUpdatedPreference(preferenceObj);
      this.hasVerifiedPhoneNumber = true;
    } else {
      evt.originalEvent.target.on = preferenceObj.status;
      const config = {
        id: categoryNk,
        preferenceObj,
        callbackFromToggle: true
      };

      this.ngEditPhoneNumberService.contactConfig = config;
      if (this.isTextMessage(preferenceObj)) {
        this.hasVerifiedPhoneNumber = false;
      }
    }
    return;
  }

  updateOnEnterKeypress(event: JQueryEventObject) {
    if (event.key === 'Enter' && _4.isFunction(this.submitCallback)) {
      this.submitCallback();
    }
  }
}

export class NotificationSettingsCkecklistComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-notification-settings/src/components/notification_settings_checklist/notification_settings_checklist.html';
  public controller: any = NotificationSettingsCkecklistController;
  public bindings: any = {
    category: '<',
    submitCallback: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/components/notification_settings_checklist/notification_settings_checklist_controller.ts